import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";
import {
  HiChartBar,
  HiDocumentText,
  HiUserGroup,
  HiUsers,
  HiAcademicCap,
  HiChatBubbleLeftRight,
  HiCog6Tooth,
  HiQuestionMarkCircle,
  HiChatBubbleBottomCenterText,
  HiChartBarSquare,
  HiClipboardDocumentList,
  HiDocumentCheck,
  HiChevronRight,
  HiClipboardDocumentCheck,
  HiMegaphone,
  HiCreditCard,
  HiDocumentMagnifyingGlass,
  HiCalendarDays,
  HiPresentationChartBar,
  HiShoppingCart,
  HiBookmark,
  HiShoppingBag,
  HiReceiptPercent,
  HiXMark
} from "react-icons/hi2";
import { routes } from "../../../helper/routes";
import config from "../../../helper/config";
import { customerConstants } from "../../../helper/constants";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

const examsSubmenuItems = [
  {
    key: "my-exams",
    icon: <HiClipboardDocumentList />,
    label: "My Exams",
    to: routes.my_exams,
  },
  {
    key: "available-exams",
    icon: <HiDocumentMagnifyingGlass />,
    label: "Available Exams",
    to: routes.available_exams,
  },
  {
    key: "grade-reports",
    icon: <HiPresentationChartBar />,
    label: "Grade Reports",
  },
];

const myAccountSubmenuItems = [
  {
    key: "profile",
    icon: <HiUserGroup />,
    label: "Profile",
    to: routes.profile,
  },
  {
    key: "orders",
    icon: <HiClipboardDocumentList />,
    label: "Orders",
    to: routes.my_account_orders,
  },
  {
    key: "invoice-billing",
    icon: <HiReceiptPercent />,
    label: "Invoice / Billing",
    to: routes.my_account_invoices,
  },
  {
    key: "saved-items",
    icon: <HiBookmark />,
    label: "Saved Items",
    to: routes.saved_items,
  },
  {
    key: "my-cart",
    icon: <HiShoppingCart />,
    label: "My Cart",
    to: routes.my_cart,
  },
  {
    key: "my-products-services",
    icon: <HiShoppingBag />,
    label: "My Products / Services",
    to: routes.assess_subscriptions,
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      nodeTitle: "Assessment Subscriptions",
      privilege_view: 1,
      mid: 100,
      main_table_id: 10,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null,
      flg_list_active: 1,
      form_list_id: 46,
    },
  },
];

const studentMyAccountSubmenuItems = [
  {
    key: "profile",
    icon: <HiUserGroup />,
    label: "Profile",
    to: routes.profile,
  },
  {
    key: "orders",
    icon: <HiClipboardDocumentList />,
    label: "Orders",
    to: routes.my_account_orders,
  },
  {
    key: "billing-invoice",
    icon: <HiReceiptPercent />,
    label: "Billing / Invoice",
    to: routes.my_account_invoices,
  },
  {
    key: "saved-items-my-cart",
    icon: <HiShoppingCart />,
    label: "Saved Items and My Cart",
    to: routes.my_cart,
  },
  {
    key: "my-products-services",
    icon: <HiShoppingBag />,
    label: "My Products / Services",
    to: routes.assess_subscriptions,
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      nodeTitle: "Assessment Subscriptions",
      privilege_view: 1,
      mid: 100,
      main_table_id: 10,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null,
      flg_list_active: 1,
      form_list_id: 46,
    },
  },
];

const adminManageSubmenuItems = [
  {
    key: "manage-students",
    icon: <HiAcademicCap />,
    label: "Students",
    to: "/manage-student",
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      breadcrumb2: "Students",
      nodeTitle: "",
      privilege_view: 1,
      mid: 100,
      main_table_id: 2,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null,
    },
  },
  {
    key: "manage-employees",
    icon: <HiUserGroup />,
    label: "Employees",
    to: "/manage-teacher",
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      breadcrumb2: "employees",
      nodeTitle: "",
      mid: 100,
      main_table_id: 10,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("table_log_id"),
      lg_user_table_id: sessionStorage.getItem("manage_user_id"),
      user_list_restriction: null,
    },
  },
  {
    key: "manage-parents",
    icon: <HiUserGroup />,
    label: "Parents / Guardians",
    to: "/manage-parent",
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      breadcrumb2: "parents",
      nodeTitle: "",
      mid: 100,
      main_table_id: 3,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("table_log_id"),
      lg_user_table_id: sessionStorage.getItem("manage_user_id"),
      user_list_restriction: null,
    },
  },
  {
    key: "manage-announcements",
    icon: <HiMegaphone />,
    label: "Manage Announcements",
    to: "/manage_announcement",
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      privilege_view: 1,
      breadcrumb2: "manage_announcement",
      nodeTitle: "",
      mid: 100,
      main_table_id: 10,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("table_log_id"),
      lg_user_table_id: sessionStorage.getItem("manage_user_id"),
      user_list_restriction: null,
      flg_list_active: null,
      node_mid_actual: null,
    },
  },
  {
    key: "manage-approvals",
    icon: <HiChatBubbleLeftRight />,
    label: "Approvals",
    to: "/manage-invitations",
  },
  {
    key: "manage-user-package-subscriptions",
    icon: <HiShoppingBag />,
    label: "User Package Subscriptions",
    to: routes.admin_user_package_subscriptions,
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      nodeTitle: "Assessment Subscription",
      privilege_view: 1,
      mid: 100,
      main_table_id: 2,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null,
      flg_list_active: 1,
      form_list_id: 46,
    }
  },
  {
    key: "manage-user-assessment-purchasings",
    icon: <HiClipboardDocumentList />,
    label: "User Assessment Purchasings",
    to: routes.admin_user_assessment_purchasings,
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      nodeTitle: "Assessment Subscription",
      privilege_view: 1,
      mid: 100,
      main_table_id: 2,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null,
      flg_list_active: 1,
      form_list_id: 46,
    }
  },
];

const adminOrderSalesSubmenuItems = [
  {
    key: "admin-orders",
    icon: <HiShoppingBag />,
    label: "Orders",
    to: routes.admin_order_management_orders,
  },
  {
    key: "admin-invoices",
    icon: <HiReceiptPercent />,
    label: "Invoice",
    to: routes.admin_order_management_invoices,
  },
];

const adminReportsStatsSubmenuItems = [
  {
    key: "admin-question-statistics",
    icon: <HiChartBarSquare />,
    label: "Manage Question Statistics",
    to: routes.search_question,
  },
  {
    key: "admin-reports",
    icon: <HiClipboardDocumentList />,
    label: "Reports",
    to: "/user-reports",
  },
];

const examCreditFeesAdditionalState = {
  privilege_edit: 1,
  privilege_add: 1,
  privilege_delete: 1,
  nodeTitle: "Manage Papers",
  privilege_view: 1,
  mid: 100,
  main_table_id: 10,
  owner_restriction: null,
  lg_user_id: sessionStorage.getItem("manage_user_id"),
  lg_user_table_id: sessionStorage.getItem("table_log_id"),
  user_list_restriction: null,
  flg_list_active: 1,
  form_list_id: 10,
};

const adminCreditFeeSubmenuItems = [
  {
    key: "credit-fee-currency-types",
    icon: <HiCreditCard />,
    label: "Currency Types",
    to: routes.credit_fee_currency_types,
  },
  {
    key: "credit-fee-purchase-methods",
    icon: <HiDocumentCheck />,
    label: "Purchase Methods",
    to: routes.credit_fee_purchase_methods,
  },
  {
    key: "credit-fee-credit-categories",
    icon: <HiClipboardDocumentList />,
    label: "Credit Categories",
    to: routes.credit_fee_credit_categories,
  },
  {
    key: "credit-fee-exam-fees",
    icon: <HiDocumentText />,
    label: "Exam Credit / Fees",
    to: routes.paper_mapping,
    additionalState: examCreditFeesAdditionalState,
  },
  {
    key: "credit-fee-credit-package",
    icon: <HiShoppingBag />,
    label: "Credit Package",
    to: routes.credit_fee_credit_package,
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      nodeTitle: "Credit Package",
      privilege_view: 1,
      mid: 100,
      main_table_id: 2,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null,
      flg_list_active: 1,
      form_list_id: 46,
    }
  },
  {
    key: "credit-fee-package-credit-price",
    icon: <HiReceiptPercent />,
    label: "Package Credit Price",
    to: routes.credit_fee_package_credit_price,
    additionalState: {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      nodeTitle: "Package Credit Price",
      privilege_view: 1,
      mid: 100,
      main_table_id: 2,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null,
      flg_list_active: 1,
      form_list_id: 46,
    }
  },
];

const adminSettingsConfigurationsSubmenuItems = [
  {
    key: "admin-system-settings",
    icon: <HiCog6Tooth />,
    label: "System Settings",
    to: routes.manage_settings,
  },
  {
    key: "admin-credit-price",
    icon: <HiReceiptPercent />,
    label: "Credit Price",
    to: routes.credit_fee_credit_price,
  },
  {
    key: "admin-application-settings",
    icon: <HiDocumentCheck />,
    label: "Application Settings",
    children: [
      {
        key: "admin-max-credit-limit",
        icon: <HiCreditCard />,
        label: "Max Credit limit",
        to: routes.settings_config_max_credit_limit,
      },
    ],
  },
  {
    key: "admin-application-configurations",
    icon: <HiClipboardDocumentList />,
    label: "Application Configurations",
    to: routes.settings_config_application_configurations,
  },
];

const educatorQuestionsSubmenuItems = [
  {
    key: "educator-question-library",
    icon: <HiQuestionMarkCircle />,
    label: "Question Library",
    to: routes.questions_library,
  },
  {
    key: "educator-question-passages",
    icon: <HiChatBubbleBottomCenterText />,
    label: "Question Passages",
    to: routes.question_passage,
  },
];

const educatorExamsSubmenuItems = [
  {
    key: "educator-assessment-library",
    icon: <HiClipboardDocumentList />,
    label: "Assessment Library",
    to: routes.view_assessment,
  },
  {
    key: "educator-paper-review",
    icon: <HiClipboardDocumentCheck />,
    label: "Paper Review",
    to: routes.view_assessment_review,
  },
];

const Sidebar = (props) => {
  const [openMenus, setOpenMenus] = useState({
    exams: false,
    myAccount: false,
    adminManage: false,
    adminOrderSales: false,
    adminReportsStats: false,
    adminCreditFee: false,
    adminSettingsConfigurations: false,
    "admin-application-settings": false,
    educatorQuestions: false,
    educatorExams: false,
  });
  const location = useLocation();
  const employeeType = sessionStorage.getItem("employeeType");
  const isMobileOpen = !!props.isMobileOpen;

  const closeMobileSidebar = () => {
    if (props.onMobileClose) {
      props.onMobileClose();
    }
  };

  const handleOutsideClick = (event) => {
    const sidebar = document.querySelector(".sidebar");
    const burgerButton = document.querySelector(".mobile-burger-menu");

    if (sidebar && !sidebar.contains(event.target) &&
      burgerButton && !burgerButton.contains(event.target)) {
      if (window.innerWidth <= 768 && isMobileOpen) {
        closeMobileSidebar();
      }
    }
  };

  useEffect(() => {
    document.body.addEventListener("click", handleOutsideClick);

    return () => {
      document.body.removeEventListener("click", handleOutsideClick);
    };
  }, [isMobileOpen]);

  useEffect(() => {
    if (props.onToggle) {
      props.onToggle(true);
    }
  }, [props.onToggle]);

  const isDesktop = () => window.innerWidth > 768;

  const renderMenuContent = (icon, label, trailing = null) => (
    <div className="sidebar-menu-row">
      <div className="sidebar-menu-main">
        <div className="sidebar-icon-wrapper">{icon}</div>
        <span className="sidebar-label">{label}</span>
      </div>
      {trailing && <span className="sidebar-menu-trailing">{trailing}</span>}
    </div>
  );

  const renderMenuItem = (to, icon, label, additionalState = {}) => {
    const isActive = location.pathname === to;

    const handleClick = () => {
      if (window.innerWidth <= 768) {
        closeMobileSidebar();
      }
    };

    return (
      <li key={to} className={isActive ? "active" : ""}>
        <Link
          className="sidebar-menu-link"
          to={{ pathname: to, state: { ...additionalState } }}
          onClick={handleClick}
        >
          {renderMenuContent(icon, label)}
        </Link>
      </li>
    );
  };

  const renderDisabledMenuItem = (key, icon, label) => (
    <li key={key}>
      <button
        type="button"
        className="sidebar-parent-button sidebar-submenu-button-disabled"
      >
        {renderMenuContent(icon, label)}
      </button>
    </li>
  );

  const toggleSubmenu = (menuKey) => {
    setOpenMenus((prev) => {
      const nextIsOpen = !prev[menuKey];
      const resetMenus = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});

      return {
        ...resetMenus,
        [menuKey]: nextIsOpen,
      };
    });
  };

  const toggleNestedSubmenu = (menuKey) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey],
    }));
  };

  const isSubmenuItemActive = (to) => !!to && location.pathname === to;

  const itemHasActiveMatch = (item) =>
    isSubmenuItemActive(item.to) || (item.children ? item.children.some(itemHasActiveMatch) : false);

  const hasActiveChild = (items) =>
    items.some(itemHasActiveMatch);

  useEffect(() => {
    setOpenMenus((prev) => ({
      ...prev,
      exams: hasActiveChild(examsSubmenuItems) ? true : prev.exams,
      myAccount: (hasActiveChild(myAccountSubmenuItems) || hasActiveChild(studentMyAccountSubmenuItems))
        ? true
        : prev.myAccount,
      adminManage: hasActiveChild(adminManageSubmenuItems) ? true : prev.adminManage,
      adminOrderSales: hasActiveChild(adminOrderSalesSubmenuItems) ? true : prev.adminOrderSales,
      adminReportsStats: hasActiveChild(adminReportsStatsSubmenuItems) ? true : prev.adminReportsStats,
      adminCreditFee: hasActiveChild(adminCreditFeeSubmenuItems) ? true : prev.adminCreditFee,
      adminSettingsConfigurations: hasActiveChild(adminSettingsConfigurationsSubmenuItems)
        ? true
        : prev.adminSettingsConfigurations,
      "admin-application-settings": adminSettingsConfigurationsSubmenuItems
        .some((item) => item.key === "admin-application-settings" && item.children?.some(itemHasActiveMatch))
        ? true
        : prev["admin-application-settings"],
      educatorQuestions: hasActiveChild(educatorQuestionsSubmenuItems) ? true : prev.educatorQuestions,
      educatorExams: hasActiveChild(educatorExamsSubmenuItems) ? true : prev.educatorExams,
    }));
  }, [location.pathname]);

  const renderSubmenuItem = ({ key, icon, label, to, additionalState = {}, children }) => {
    const itemIsActive = itemHasActiveMatch({ key, to, children });

    if (children?.length) {
      const isOpen = !!openMenus[key];

      return (
        <li
          key={key}
          className={`sidebar-parent-item sidebar-submenu-item ${isOpen ? "submenu-open" : ""} ${itemIsActive ? "active" : ""}`}
        >
          <button
            type="button"
            className="sidebar-parent-button sidebar-submenu-button"
            onClick={() => toggleNestedSubmenu(key)}
          >
            {renderMenuContent(
              icon,
              label,
              <HiChevronRight className={`sidebar-parent-chevron ${isOpen ? "open" : ""}`} />
            )}
          </button>
          <ul className={`sidebar-submenu-list nested ${isOpen ? "open" : ""}`}>
            {children.map(renderSubmenuItem)}
          </ul>
        </li>
      );
    }

    return (
      <li
        key={key}
        className={`sidebar-submenu-item ${isSubmenuItemActive(to) ? "active" : ""}`}
      >
        {to ? (
          <Link
            className="sidebar-submenu-button"
            to={{ pathname: to, state: { ...additionalState } }}
            onClick={() => {
              if (!isDesktop()) {
                closeMobileSidebar();
              }
            }}
          >
            {renderMenuContent(icon, label)}
          </Link>
        ) : (
          <button
            type="button"
            className="sidebar-submenu-button sidebar-submenu-button-disabled"
          >
            {renderMenuContent(icon, label)}
          </button>
        )}
      </li>
    );
  };

  const renderExpandableMenu = (menuKey, icon, label, items) => {
    const menuHasActiveChild = hasActiveChild(items);
    const isOpen = !!openMenus[menuKey];

    return (
      <li
        key={menuKey}
        className={`sidebar-parent-item ${isOpen ? "submenu-open" : ""} ${menuHasActiveChild ? "active" : ""}`}
      >
        <button
          type="button"
          className="sidebar-parent-button"
          onClick={() => toggleSubmenu(menuKey)}
        >
          {renderMenuContent(
            icon,
            label,
            <HiChevronRight className={`sidebar-parent-chevron ${isOpen ? "open" : ""}`} />
          )}
        </button>
        <ul className={`sidebar-submenu-list ${isOpen ? "open" : ""}`}>
          {items.map(renderSubmenuItem)}
        </ul>
      </li>
    );
  };

  const customer = getCustomerFeatureFlag();
  let customerPaperText, isCMC, isEdFoci;
  switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
      customerPaperText = "Papers";
      isCMC = false;
      isEdFoci = false;
      break;
    case customerConstants.EXO_CUSTOMER2:
      customerPaperText = "Past Papers";
      isCMC = true;
      isEdFoci = false;
      break;
    case customerConstants.EDF_CUSTOMER3:
      customerPaperText = "Courses";
      isCMC = false;
      isEdFoci = true;
      break;
    default:
      customerPaperText = "Search";
      isCMC = false;
      isEdFoci = true;
      break;
  }

  return (
    <>
      {isMobileOpen && (
        <div
          className="sidebar-overlay"
          onClick={closeMobileSidebar}
        />
      )}

      <nav
        className={`sidebar expanded ${isMobileOpen ? "mobile-open" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sidebar-mobile-header">
          <button
            type="button"
            className="sidebar-mobile-close"
            onClick={closeMobileSidebar}
            aria-label="Close sidebar"
          >
            <HiXMark />
          </button>
        </div>
        <ul className="list-unstyled components">
          {renderMenuItem("/manage-dashboard", <HiChartBar />, "Dashboard")}

          {/* {!isEdFoci && !isCMC && props.isAdmin &&
            renderMenuItem(
              "/search-papers",
              <HiDocumentMagnifyingGlass />,
              "Find" + " " + customerPaperText
            )
          } */}

          {/* {!!props.isAdmin &&
            !isEdFoci && !isCMC &&
            renderMenuItem(
              routes.assess_subscriptions,
              <HiCreditCard />,
              "Assessment Subscription",
              {
                privilege_edit: 1,
                privilege_add: 1,
                privilege_delete: 1,
                nodeTitle: "Assessment Subscription",
                privilege_view: 1,
                mid: 100,
                main_table_id: 2,
                owner_restriction: null,
                lg_user_id: sessionStorage.getItem("manage_user_id"),
                lg_user_table_id: sessionStorage.getItem("table_log_id"),
                user_list_restriction: null,
                flg_list_active: 1,
                form_list_id: 46,
              }
            )} */}

          {!isEdFoci && (props.isStudent || props.isParent) &&
            renderExpandableMenu(
              "exams",
              <HiDocumentText />,
              "Exams",
              examsSubmenuItems
            )
          }
          {!!props.isAdmin &&
            !isEdFoci &&
            renderExpandableMenu(
              "adminManage",
              <HiUsers />,
              "Manage",
              adminManageSubmenuItems.filter((item) =>
                (item.key !== "manage-parents" || !isCMC) &&
                (item.key !== "manage-approvals" || !isCMC)
              )
            )}

          {!!props.isStudent &&
            !isEdFoci &&
            sessionStorage.getItem("manage_user_id") && (
              <>
                {renderExpandableMenu(
                  "myAccount",
                  <HiClipboardDocumentList />,
                  "My Account",
                  studentMyAccountSubmenuItems
                )}
                {renderMenuItem("/announcements", <HiMegaphone />, "Announcements", {
                  privilege_edit: null,
                  privilege_add: null,
                  privilege_delete: null,
                  privilege_view: 1,
                  breadcrumb2: "announcement",
                  nodeTitle: "",
                  mid: 100,
                  main_table_id: 2,
                  owner_restriction: null,
                  lg_user_id: sessionStorage.getItem("manage_user_id"),
                  lg_user_table_id: sessionStorage.getItem("table_log_id"),
                  user_list_restriction: null,
                  flg_list_active: null,
                  node_mid_actual: null,
                })}
                {/* {renderDisabledMenuItem(
                  "student-feedbacks-reviews",
                  <HiChatBubbleLeftRight />,
                  "Feedbacks and Reviews"
                )} */}
              </>
            )
          }


          {!!props.isParent &&
            !isEdFoci &&
            sessionStorage.getItem("parent_group_id") &&
            sessionStorage.getItem("parent_group_user_table_id") && (
              <>
                {renderMenuItem("/assess-subscriptions", <HiCreditCard />, "Assessment Subscriptions", {
                  privilege_edit: 1,
                  privilege_add: 1,
                  privilege_delete: 1,
                  privilege_view: 1,
                  nodeTitle: "Assessment Subscriptions",
                  mid: 100,
                  main_table_id: 10,
                  owner_restriction: null,
                  lg_user_id: sessionStorage.getItem("manage_user_id"),
                  lg_user_table_id: sessionStorage.getItem("table_log_id"),
                  user_list_restriction: null,
                  flg_list_active: 1,
                  form_list_id: 46,
                })}
                {renderExpandableMenu(
                  "myAccount",
                  <HiClipboardDocumentList />,
                  "My Account",
                  myAccountSubmenuItems
                )}
              </>
            )
          }

          {!!props.isParent &&
            renderMenuItem(
              "/register-student",
              <HiUsers />,
              "Students",
              {
                privilege_edit: 1,
                privilege_add: 1,
                privilege_delete: 1,
                breadcrumb2: "Student Registration",
                nodeTitle: "",
                mid: 100,
                main_table_id: 10,
                owner_restriction: null,
                lg_user_id: sessionStorage.getItem("table_log_id"),
                lg_user_table_id: sessionStorage.getItem("manage_user_id"),
                user_list_restriction: null,
              }
            )
          }

          {!!props.isStudent &&
            !isEdFoci &&
            !isCMC &&
            renderMenuItem(
              "/my-requests",
              <HiUserGroup />,
              "Parents / Guardians",
              {
                privilege_edit: 1,
                privilege_add: 1,
                privilege_delete: 1,
                breadcrumb2: "Parent Requests",
                nodeTitle: "",
                privilege_view: 1,
                mid: 100,
                main_table_id: 10,
                owner_restriction: null,
                lg_user_id: sessionStorage.getItem("manage_user_id"),
                lg_user_table_id: sessionStorage.getItem("table_log_id"),
                user_list_restriction: null,
              }
            )
          }

          {!!props.isTeacher && (employeeType === "DEOP" || employeeType === "MASAD") &&
            renderExpandableMenu(
              "educatorQuestions",
              <HiQuestionMarkCircle />,
              "Questions",
              educatorQuestionsSubmenuItems
            )
          }

          {!!props.isTeacher && (employeeType === "DEOP" || employeeType === "MASAD") &&
            renderExpandableMenu(
              "educatorExams",
              <HiClipboardDocumentList />,
              "Exams",
              educatorExamsSubmenuItems
            )
          }

          {!!props.isTeacher && (employeeType === "DEOP" || employeeType === "MASAD") &&
            renderMenuItem(
              routes.paper_mapping,
              <HiDocumentText />,
              "Exam Credit / Fees",
              examCreditFeesAdditionalState
            )
          }

          {!!props.isTeacher && (employeeType === "DEOP" || employeeType === "MASAD") &&
            renderMenuItem(routes.settings_view, <HiCog6Tooth />, "Settings / Configs")
          }

          {!!props.isTeacher &&
            !isEdFoci &&
            renderMenuItem("/announcements", <HiMegaphone />, "Announcements", {
              privilege_edit: props.isTeacher ? 1 : null,
              privilege_add: props.isTeacher ? 1 : null,
              privilege_delete: null,
              privilege_view: 1,
              breadcrumb2: "announcement",
              nodeTitle: "",
              mid: 100,
              main_table_id: props.isTeacher ? 10 : 2,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null,
              flg_list_active: null,
              node_mid_actual: null,
            })
          }

          {!!props.isAdmin &&
            !isEdFoci && !isCMC &&
            renderExpandableMenu(
              "adminCreditFee",
              <HiCreditCard />,
              "Credit / Fee Management",
              adminCreditFeeSubmenuItems
            )}

          {!!props.isAdmin &&
            renderExpandableMenu(
              "adminOrderSales",
              <HiShoppingBag />,
              "Order / Sales Management",
              adminOrderSalesSubmenuItems
            )
          }

          {!!props.isAdmin &&
            renderExpandableMenu(
              "adminSettingsConfigurations",
              <HiCog6Tooth />,
              "Settings and Configurations",
              adminSettingsConfigurationsSubmenuItems
            )
          }

          {!!props.isAdmin &&
            renderExpandableMenu(
              "adminReportsStats",
              <HiChartBarSquare />,
              "Reports / Stats",
              adminReportsStatsSubmenuItems
            )
          }

          {!!props.isTeacher &&
            employeeType === "TEACH" &&
            renderMenuItem(
              routes.view_assessment_review,
              <HiClipboardDocumentCheck />,
              "Paper Review"
            )
          }

          {
            (employeeType === "MASAD") &&
            renderMenuItem(
              routes.assessment_template,
              <HiDocumentCheck />,
              "Assessment Template"
            )
          }

          {(!!props.isParent) &&
            !isEdFoci &&
            renderMenuItem("/announcements", <HiMegaphone />, "Announcements", {
              privilege_edit: props.isTeacher ? 1 : null,
              privilege_add: props.isTeacher ? 1 : null,
              privilege_delete: null,
              privilege_view: 1,
              breadcrumb2: "announcement",
              nodeTitle: "",
              mid: 100,
              main_table_id: props.isTeacher ? 10 : 2,
              owner_restriction: null,
              lg_user_id: sessionStorage.getItem("manage_user_id"),
              lg_user_table_id: sessionStorage.getItem("table_log_id"),
              user_list_restriction: null,
              flg_list_active: null,
              node_mid_actual: null,
            })
          }

          {isEdFoci &&
            renderMenuItem("/manage-sitemap", <HiDocumentCheck />, "Site Map")
          }

          {isEdFoci &&
            renderMenuItem("/main-calendar", <HiCalendarDays />, "Calendar")
          }
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
